exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-cards[data-v-f71c924c]{display:flex;flex-direction:column;gap:1rem}", ""]);

// exports
